import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";

export default function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try { await forgotPassword(email); setDone(true); }
    catch (ex) { setErr(formatApiError(ex.response?.data?.detail) || ex.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-8">
      <div className="w-full max-w-sm" data-testid="forgot-password-page">
        <img src={LOGO_URL} alt="OnchainLyfe" className="h-8 mb-8" />
        {done ? (
          <div data-testid="forgot-success">
            <h1 className="font-display text-3xl font-bold">Check your inbox</h1>
            <p className="text-zinc-400 text-sm mt-3 leading-relaxed">
              If an account exists for <span className="text-white">{email}</span>, we've sent a link to reset your password. It expires in 1 hour.
            </p>
            <p className="text-sm text-zinc-500 mt-8">
              <Link to="/login" className="text-[#ccff00] hover:underline">Back to log in</Link>
            </p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-password-form">
            <h1 className="font-display text-3xl font-bold">Reset your password</h1>
            <p className="text-zinc-400 text-sm mt-1 mb-6">Enter your email and we'll send you a reset link.</p>
            {err && <div data-testid="forgot-error" className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">{err}</div>}
            <label className="block text-xs font-mono-cl tracking-[0.14em] uppercase text-zinc-500 mb-1.5">Email</label>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full mb-6 rounded-xl bg-[#0d0d0d] border border-white/10 px-4 py-3 text-sm focus:border-[#ccff00]/50 focus:outline-none" placeholder="you@fund.com" />
            <button data-testid="forgot-submit" disabled={busy} className="w-full py-3 rounded-full bg-[#ccff00] text-black font-semibold text-sm hover:brightness-110 transition-[filter] disabled:opacity-60">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <p className="text-center text-sm text-zinc-500 mt-6">
              Remembered it? <Link to="/login" className="text-[#ccff00] hover:underline">Log in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
